/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2590
 */

module.exports = require(/* 2591 */"./2591/index")
